<template>
  <div class="b">
    <Nav current="公司后台"></Nav>
    <div class="top">
      <div class="el-breadcrumb">数据分库>切分项目</div>
      <div class="hncForm">
        <el-form ref="form" :model="formData" label-width="116px" size="medium">
          <!-- 基本信息 begin -->
          <div class="bl">
            <div class="inner">
              <div class="title">基本资源信息</div>
              <div style="display: flex; margin-top: 30px;">
                <el-form-item label="分库前系统信息">
                  <span style="position: absolute;top: -28px;left: 0;font-size: 12px; color: red;">源系统名称/源系统域名/分库之前数据源名称</span>
                  <el-cascader
                  ref="refSubCat1"
                  placeholder="请选择源系统名称/源系统域名/分库之前数据源名称"
                  v-model="formData.historyCascaderValue"
                  :options="listFkInfo1"
                  @change="change(formData,'formDataBefore')"
                  :props="{label :'name', value :'id'}"></el-cascader>
                </el-form-item>
                <el-form-item label="条件的类型">
                  <el-select v-model="conditionType" placeholder="请选择您要查找的条件的类型">
                    <el-option label="组织机构" value="conditionType"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div style="display: flex; margin-top: 20px;">
                <el-form-item label="系统信息">
                  <span style="position: absolute;top: -28px;left: 0;font-size: 12px; color: red;">源系统名称/源系统域名/默认数据源名称（不符合分发规则的数据存储）/源表单名称</span>
                  <el-cascader
                  ref="refSubCat"
                  placeholder="请选择源系统名称/源系统域名/默认数据源名称（不符合分发规则的数据存储）/源表单名称"
                  v-model="formData.cascaderValue"
                  :options="listFkInfo"
                  @change="change(formData,'formData')"
                  :props="{label :'name', value :'id'}"></el-cascader>
                </el-form-item>
              </div>
            </div>
          </div>
          <!-- 基本信息 end -->
          <!-- 大分组 begin -->
          <div class="bl" v-for="(item,index) in formData.timeRule" :key="index">
            <div class="inner">
              <div class="title clearfix">
                <div class="l icon">分库规则{{intToChinese(index+1)}}</div>
                <!-- <div v-if="index > 0" class="r dele icon" @click="bigDele(index)">删除</div> -->
                <div v-if="index === 0" class="r add icon" @click="bigAdd">添加分库规则条件</div>
              </div>
              <!-- 时间设置 -->
              <div class="flex mb20 borderb">
                <el-form-item label="开始的日期">
                  <el-date-picker
                    :disabled="item.id ? true : false"
                    v-model="item.startTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束的日期">
                  <el-date-picker
                    :disabled="item.id ? true : false"
                    v-model="item.endTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </div>
              <!-- 小分组 begin -->
              <div class="innerGroup" v-for="(e,j) in item.expression" :key="j">
                <span class="circle"></span>
                <div style="display: flex">
                  <el-form-item label="分发系统信息">
                    <el-cascader
                    @change="change(e)"
                    placeholder="请选择分发系统名称/分发系统域名/默认数据分发名称"
                    v-model="e.cascaderValue"
                    :options="listFkInfo1"
                    :props="{label :'name', value :'id'}"></el-cascader>
                  </el-form-item>
                  <div v-if="j > 0" class="dele icon" @click="smallDele(index,j)">删除</div>
                </div>
                <!-- <el-form-item class="dataSource" label="数据源名称">
                  <el-select :disabled="e.id ? true : false" v-model="e.targetDatasource" placeholder="请选择您要筛选的数据库">
                    <el-option v-for="(item,index) in dataSource" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <div v-if="j > 0" class="dele icon" @click="smallDele(index,j)">删除</div>
                </el-form-item> -->
                <el-form-item label="组织的节点">
                  <el-input :disabled="e.id ? true : false" v-if="e.id"  v-model="e.departmentListName" placeholder="请选择您所要筛选的组织节点"></el-input>
                  <el-input :disabled="e.id ? true : false" v-else v-model="e.departmentListName"
                    @click.native="inputClick(index,j)" placeholder="请选择您所要筛选的组织节点"></el-input>
                </el-form-item>
              </div>
              <!-- 小分组 end -->
              <div v-if="!item.id" @click="smallAdd(index)" class="add icon clearfix">
                  添加筛选条件
              </div>
            </div>
          </div>
          <!-- 大分组 end -->
        </el-form>
      </div>
    </div>
    <vxe-modal v-model="dialogFormVisible" width="450" title="请选择组织的节点">
      <vxe-table
        border="none"
        resizable
        height="450"
        ref="xTree"
        row-id="id"
        width="200"
        :checkbox-config="{ labelField: 'name', highlight: true , checkStrictly: true,}"
        @checkbox-change="selectChangeEvent"
        :menu-config="{ body: { options: bodyMenus }}"
        :tree-config="{
          lazy: true,
          transform: true,
          rowField: 'id',
          children: 'children',
          hasChild: 'hasChild',
          loadMethod: loadChildrenMethod,
        }"
        :data="tableData.data"
      >
        <vxe-table-column
          field="name"
          title="名称"
          tree-node
          type="checkbox"
        ></vxe-table-column>
      </vxe-table>
      <div class="hncFormFoot">
        <el-button type="primary" @click="savaDepartmentId"
          >确定</el-button
        >
      </div>
    </vxe-modal>
    <div class="hncFormFoot hncFoot">
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Search from "@/components/Search.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import axios from "axios";
import qs from "qs";
function expressionObj(){
  return {
    cascaderValue: [],//分发系统信息
    systemId: '',//所属系统
    systemDomain: '',//所属系统域名
    targetDatasource: '',//"目标数据源1"
    departmentListName: '',
    departmentList: [],
  }
}
function timeRuleObj(){
  return {
    startTime: '',//"启动时间1",
    endTime: '',//"结束时间2",
    expression: [
      expressionObj(),
    ],
  }
}
function T(){
  return {
    cascaderValue: [],
    systemId: "", //系统id
    systemDomain: "", //系统域名
    tableName: "", //表单名称
    tableId: '',//表单id
    defDatasourceId: "", //"默认数据源",
    historyCascaderValue: [],//分库之前系统信息
    historyDatasourceId: "",//分库之前数据源ID
    timeRule: [
      timeRuleObj(),
    ]
  }
}
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      conditionType: 'conditionType',
      currentGroup: [0,0],//第一个0大分组，第二个0小分组
      records: [],
      current: "我的公司",
      pageSize: 100000,
      name: "",
      level: "",
      parentId: "",
      currentPage: 1,

      query: {},
      dataSource: [],
      listFkInfo: null,
      listFkInfo1: null,//分库规则
      listFkInfoChildren: [],
      listFkInfoChildrenChildren: [],
      formData: T(),//分库表单数据
      dialogFormVisible: false,
      bodyMenus: [
        [
          { code: 'clearLoaded', name: '清除加载状态', disabled: false },
          { code: 'reloadNodes', name: '重新加载子节点', disabled: false },
          { code: 'expand', name: '展开节点', disabled: false },
          { code: 'contract', name: '收起节点', disabled: false }
        ]
      ],
      tableData: {
        data: [],
      },
    };
  },
  mounted() {
    this.query = this.$route.query
    this.getShow()
    this.getTableHeight();
    this.getSystemInfo()
    this.getDataSource()
    this.getCompanyList()
  },
  methods: {
    loadChildrenMethod(row) {
      var _this = this;
      var id = row.row.id;
      var params = {
        parentId: id,
        name: _this.name,
        level: _this.level,
      };
      _this.parentId = id;
      return new Promise((resolve, reject) => {
        // console.log(params)
        _this.parentId = id;

        http.get(apiData.companyList, true, params, function (res) {
          var tableData = res.data.data.list;
          if (res.data.data.list.length) {
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].sonNum == 0) {
                tableData[i].hasChild = false;
                console.log(tableData[i].hasChild);
              }
            }
            resolve(tableData);
            console.log("数组长度", tableData);
          } else {
            //  _this.tableData.data.push({hasChild : false })

            _this.$message.warning("当前节点没有下级！");
          }
          _this.parentId = "";
        });
      })
        .then((res) => {
          console.log(res);
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompanyList: function () {
      var _this = this;
      var params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        parentId: _this.parentId,
        name: _this.name,
        level: _this.level,
      };
      http.get(apiData.companyList, true, params, function (res) {
        if (res.data.code == 200) {
          if (res.data.data) {
            _this.tableData.data = res.data.data.list;
            _this.totalRow = res.data.data.totalRow;
            // for (let i = 0; i < _this.tableData.data.length; i++) {
            //   if (_this.tableData.data[i].sonNum >= 1) {
            //     _this.tableData.data[i].hasChild = true;
            //   } else {
            //     _this.tableData.data[i].hasChild = false;
            //   }
            // }
          } else {
          }
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    },
    getShow(){
      let _this = this
      http.get(apiData.tableRuleDetail, true, this.query, (res) => {
        console.log(res)
        let data = res.data.data
        res.data.data.cascaderValue = [data.systemId, data.systemDomain, data.defDatasourceId, data.tableId]
        if (data.historyDatasource) {
          res.data.data.historyDatasourceId = data.historyDatasource.historyDatasourceId
          res.data.data.historyCascaderValue = [data.historyDatasource.systemId, data.historyDatasource.systemDomain, data.historyDatasource.historyDatasourceId]
        }
        let timeRule = res.data.data.timeRule

        //大分组
        for (let i = 0; i < timeRule.length; i++) {
          const element = timeRule[i].expression;
          if(element?.length){
            //小分组 expression
            for (let j = 0; j < element.length; j++) {
              const e = element[j];
              //分发系统信息
              e.cascaderValue = [e.systemId,e.systemDomain,e.targetDatasource]
              //组织的节点
              const data = JSON.parse(JSON.stringify(element[j]))
              e.departmentListName = []
              for (let k = 0; k < data.departmentList.length; k++) {
                const item = data.departmentList[k];
                e.departmentListName.push(`【${item.departmentName}】`)
              }
              e.departmentListName = e.departmentListName.join('')
              e.departmentList = e.departmentIds.split(',')
            }

          }
        }
        _this.formData = res.data.data
      });
    },
    // getShow(){
    //   let _this = this
    //   http.get(apiData.tableRuleDetail, true, this.query, (res) => {
    //     console.log(res)
    //     _this.formData = res.data.data
    //   });
    // },
    getDataSource(){
      let _this = this
      http.get(apiData.dataSourceList, true, {}, (res) => {
        if(res.data && res.data.data){
          _this.dataSource = res.data.data
        }
      });
    },
    change(e,type){
      console.log(e)
      if(type == 'formData'){
        if(e.cascaderValue && e.cascaderValue.length){
          e.systemId = e.cascaderValue[0]
          e.systemDomain = e.cascaderValue[1]
          e.defDatasourceId = e.cascaderValue[2]
          e.tableId = e.cascaderValue[3]
          e.tableName = this.$refs['refSubCat'].getCheckedNodes()[0].label
        }
      } else if (type == 'formDataBefore') {
        e.historyDatasourceId = e.historyCascaderValue[2]
      } else {
        e.systemId = e.cascaderValue[0]
        e.systemDomain = e.cascaderValue[1]
        e.targetDatasource = e.cascaderValue[2]
      }
    },
    handleChange(e){
      let _this = this
      let listFkInfo = this.listFkInfo
      _this.listFkInfoChildren = []
      _this.listFkInfoChildrenChildren = []
      _this.formData.systemDomain = ''
      _this.formData.tableName = ''
      for (let i = 0; i < listFkInfo.length; i++) {
        const element = listFkInfo[i];
        if(element.systemId == e){
          console.log(element)
          _this.listFkInfoChildren = element.children
          return
        }
      }
    },
    handleChange1(e){
      let _this = this
      let listFkInfo = _this.listFkInfoChildren
      _this.listFkInfoChildrenChildren = []
      _this.formData.tableName = ''
      for (let i = 0; i < listFkInfo.length; i++) {
        const element = listFkInfo[i];
        if(element.systemDomain == e){
          console.log(element)
          _this.listFkInfoChildrenChildren = element.tableName
          return
        }
      }
    },
    getSystemInfoSource(data,type){
      console.log(data)
      for (let i = 0; i < data.length; i++) {
        const element = data[i].children;
        for (let j = 0; j < element.length; j++) {
          const item = element[j];
          item['children'] = item.datasource
          if(type){
            for (let k = 0; k < item.children.length; k++) {
              const list = item.children[k];
              // list['children'] = []
              // for (let m = 0; m < item.table.length; m++) {
              //   item.table[m];
              //   list['children'].push({
              //     name: item.table[m].name,
              //     id: item.table[m].name
              //   })

              // }
              list['children'] = item.table
              // delete item.table;
            }
          }
          // delete item.datasource;
        }
      }
      return data//返回基本系统信息和分库规则系统信息
    },
    getSystemInfo(){
      let _this = this
      http.get(apiData.listFkInfo, true, {}, (res) => {
        if (res.data && res.data.data) {
          let listFkInfo = _this.getSystemInfoSource(JSON.parse(JSON.stringify(res.data.data)),true);
          let listFkInfo1 = _this.getSystemInfoSource(JSON.parse(JSON.stringify(res.data.data)));
          _this.listFkInfo = listFkInfo
          _this.listFkInfo1 = listFkInfo1
        }
      });
    },
    bigDele(index){
      console.log(1)
      this.formData.timeRule.splice(index,1)
    },
    smallDele(index,j){
      console.log(3)
      this.formData.timeRule[index].expression.splice(j,1)
    },
    bigAdd(){
      console.log(2)
      this.formData.timeRule.push(timeRuleObj())
    },
    smallAdd(index){
      this.formData.timeRule[index].expression.push(expressionObj())
    },
    intToChinese(str){
      str = str+'';
      var len = str.length-1;
      var idxs = ['','十','百','千','万','十','百','千','亿','十','百','千','万','十','百','千','亿'];
      var num = ['零','一','二','三','四','五','六','七','八','九'];
      return str.replace(/([1-9]|0+)/g,function( $, $1, idx, full) {
        var pos = 0;
        if( $1[0] != '0' ){
        pos = len-idx;
        if( idx == 0 && $1[0] == 1 && idxs[len-idx] == '十'){
          return idxs[len-idx];
        }
        return num[$1[0]] + idxs[len-idx];
        } else {
        var left = len - idx;
        var right = len - idx + $1.length;
        if( Math.floor(right/4) - Math.floor(left/4) > 0 ){
          pos = left - left%4;
        }
        if( pos ){
          return idxs[pos] + num[$1[0]];
        } else if( idx + $1.length >= len ){
          return '';
        }else {
          return num[$1[0]]
        }
        }
      });
    },
    inputClick(index, j) {
      let _this = this
      this.currentGroup = [index,j]
      this.dialogFormVisible = true
      this.$nextTick(() => {
        _this.$refs.xTree.clearCheckboxRow()
      })
    },
    selectChangeEvent({ $table }) {
      const records = $table.getCheckboxRecords();
      this.records = records
    },
    savaDepartmentId(){
      let _this = this
      _this.dialogFormVisible = false
      let departmentList = []
      let departmentListName = []
      for (let i = 0; i < _this.records.length; i++) {
        const element = _this.records[i];
        departmentListName.push(`【${element.name}】`)
        departmentList.push(element.id)
      }
      _this.formData.timeRule[_this.currentGroup[0]].expression[_this.currentGroup[1]].departmentList = departmentList
      _this.formData.timeRule[_this.currentGroup[0]].expression[_this.currentGroup[1]].departmentListName = departmentListName.join('')

    },
    submitForm(){
      let _this = this
      let formData = JSON.parse(JSON.stringify(this.formData))
      let timeRule = []
      if(formData.timeRule?.length){
      }else {
        return
      }
      for (let i = 0; i < formData.timeRule.length; i++) {
        const element = formData.timeRule[i];
        if(element.id){

        } else {
          if (!element.startTime) {
            _this.$message.error('规则启动时间不能为空');
            return
          }
          if (element.expression && element.expression.length) {
            for (let j = 0; j < element.expression.length; j++) {
              const ele = element.expression[j];
              if (!ele.systemDomain || !ele.systemId || !ele.targetDatasource) {
                _this.$message.error('分发系统信息不能为空');
                return
              } else if (!(ele.departmentList && ele.departmentList.length) || !ele.departmentListName) {
                _this.$message.error('组织的节点不能为空');
                return
              }
            }
          }
          timeRule.push(element)
        }
      }
      
      let params = {
        id: formData.id,
        systemId: formData.systemId,
        systemDomain: formData.systemDomain,
        tableName: formData.tableName,
        timeRule: timeRule
      }
      http.post(apiData.tableRuleTimeAdd, true, params, (res) => {
        console.log(res)
        if (res.data.code == 200) {
          _this.$message.success("新建成功");
          _this.$router.push({ name: "Sharding"});
        } else {
          _this.$message.error(res.data.msg);
        }
      },null,'post',true);

    },
    getTableHeight(){
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        let commonTopbar = document.querySelector('.commonTopbar').offsetHeight;
        let header = document.querySelector('.header').offsetHeight;
        this.tableHeight = parseInt(this.clientHeight - commonTopbar - header - 180);
      })
    },
    deleteHandle(row){
      console.log(row)
      this.dialogDeleteVisible = true
    },
    addSystem(type,row) {
      this.dialogFormVisible = true
      if(type == 1){//add

      }else if(type == 2){

      }
    },
    //编辑
    editHandle(row) {
      this.$router.push({ name: "EditSystem", query: { id: row.id } });
    },
    deleHandle() {
      let _this = this;
      let id = _this.deleteObj.id;
      http.delete(apiData.systemDelete, true, { id }, (res) => {
        if (res.data.code == 200) {
          _this.isShowDelete = false;
          _this.getTableHeight();
          _this.$message.success("删除成功");
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    },
    searchRole() {
      var _this = this;
      http.get(
        apiData.systemList,
        true,
        { name: this.name, userName: this.userName },
        (res) => {
          this.tableData = res.data.data.list;
        }
      );
    },
      disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
  },

};
</script>
<style scoped lang="less">
@import "./index.less";
.hncForm {
  .el-form {
    padding: 0;
    margin: 0;
    background: #fff;
  }
}
.b {
  display: flex;
  flex-direction: column;
  color: #000;
  .top {
    flex: 1;
    overflow: auto;
    .el-breadcrumb {
      margin: 10px 0;
      font-size: 14px;
      color: #54C4B8;
      font-weight: bold;
    }
    .hncForm {
      margin: 10px 0;
      /deep/
      .el-form-item__label {
        color: #000;
      }
    }
    .bl {
      margin-bottom: 20px;
      padding: 20px;
      background: #f8f8f8;
      .inner {
        .icon {
          display: flex;
          align-items: center;
          &::before {
            margin-right: 5px;
            display: inline-block;
            content: '';
            width: 20px;
            height: 20px;
            background: red;
          }
          &.dele {
            margin-left: 20px;
            color: #54C4B8;
            cursor: pointer;
            &::before {
              background: url('../../images/sharding/delete.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .title {
          padding: 5px 10px;
          margin-bottom: 20px;
          font-weight: 400;
          font-style: normal;
          font-size: 18px;
          background: #ddd;
          >.l {
            &::before {
              background: url('../../images/sharding/chose.png') no-repeat;
              background-size: 100% 100%;
            }
          }
          .add {
            color: #FFB816;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            &::before {
              background: url('../../images/sharding/add.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        >.add {
          font-weight: bold;
          font-size: 14px;
          color: #54C4B8;
          cursor: pointer;
          &::before {
            margin-right: 14px;
            background: url('../../images/sharding/smallAdd.png') no-repeat;
            background-size: 100% 100%;
          }
        }
        .flex {
          display: flex;
        }
        .innerGroup {
          position: relative;
          padding: 20px 0 10px 0;
          border-radius: 5px;
          .circle {
            position: absolute;
            top: 34px;
            left: 8px;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #000;
          }
          /deep/
          .dataSource {
            .el-form-item__content {
              display: flex;
              .el-select {
                flex: 1;
              }
            }
          }
        }
        .cursor {
          input {
            cursor: pointer;
          }
        }
      }
    }
  }
  .hncFoot {
    margin: 30px auto;
  }
}

</style>